import { RoleSelection } from "@/components/auth/role-selection";
import { LoginPageLayout } from "@/components/shadcn-studio/blocks/login-page-03/login-page-03";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(org)/o/$orgSlug/select-role")({
  component: SelectRolePage,
});

function SelectRolePage() {
  return (
    <LoginPageLayout>
      <RoleSelection />
    </LoginPageLayout>
  );
}
